import type { ButtonHTMLAttributes } from "react";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary";
}

export default function Button({
  variant = "primary",
  children,
  ...rest
}: Props): JSX.Element {
  const isPrimary = variant === "primary";
  return (
    <button
      {...rest}
      style={{
        width: "100%",
        padding: "0.6rem 1rem",
        background: isPrimary ? "var(--accent)" : "transparent",
        color: isPrimary ? "white" : "var(--fg)",
        border: `1px solid ${isPrimary ? "var(--accent)" : "var(--border)"}`,
        borderRadius: 6,
        fontSize: 14,
        fontWeight: 500,
        cursor: rest.disabled ? "not-allowed" : "pointer",
        opacity: rest.disabled ? 0.6 : 1,
      }}
    >
      {children}
    </button>
  );
}
